import React from "react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const PlayerAvatar = ({ player, className = "w-9 h-9" }) => {
  if (player?.photo_id) {
    return (
      <span className={`relative inline-flex shrink-0 ${className}`}>
        <img
          src={`${BACKEND}/api/attachments/${player.photo_id}/file`}
          alt={player.name || ""}
          className="w-full h-full rounded-full object-cover border border-purple-200"
          data-testid={`player-avatar-${player.id}`}
        />
        {player.dorsal != null && (
          <span className="absolute -bottom-1 -right-1 bg-purple-600 text-white text-[9px] font-black rounded-full min-w-4 h-4 px-0.5 grid place-items-center border border-white">
            {player.dorsal}
          </span>
        )}
      </span>
    );
  }
  return (
    <span className={`inline-flex rounded-full bg-purple-100 text-purple-800 font-black items-center justify-center text-sm shrink-0 ${className}`}>
      {player?.dorsal ?? "-"}
    </span>
  );
};
